<template>
	<div
		class="ms-popup-main"
		v-show="active"
		v-if="!forceRender || (active && forceRender)"
		@keydown="onKeydown"
	>
		<div class="semi-blackScreen"></div>
		<msDragable
			ref="dragable"
			:w="widthx"
			:h="heightx"
			:z="1100"
			:x="posX"
			:y="posY"
			:style="[heightDefault, customSize]"
			:isResizable="false"
			:isDraggable="isDraggable"
			@dragstop="offDraggable"
			:class="[
				{ 'right-to-left': animation == 'right-to-left' },
				{ 'user-select-off': isDraggable },
			]"
		>
			<div
				class="ms-popup"
				:class="[
					cssPopup,
					{ fullScreen: fullScreen },
					`placement-${placement}`,
				]"
			>
				<!-- btn help -->
				<div
					class="btn-help"
					@click="showHelp"
					v-tooltip="'Hướng dẫn'"
					v-if="helpPath"
				>
					<div class="mi mi-24 mi-help"></div>
				</div>
				<!-- btn close -->
				<div
					class="btn-close"
					@click="closePopup"
					v-tooltip="'Đóng'"
					v-if="iconClose"
				>
					<div class="mi mi-24 mi-close-popup"></div>
				</div>
				<div
					@mousedown="onDraggable"
					:class="[cssHeader, { 'popup-header': defaultCssHeader }]"
					v-if="$slots.header"
				>
					<slot name="header"></slot>
				</div>
				<div
					:class="[cssContent, { 'popup-content': defaultCssContent }]"
					ref="content"
					v-if="$slots.content"
				>
					<slot name="content"></slot>
				</div>
				<div
					:class="[cssFooter, { 'popup-footer': defaultCssFooter }]"
					v-if="$slots.footer"
				>
					<slot name="footer"></slot>
				</div>
			</div>
		</msDragable>
		<input @focus="focusFirstControl" class="input-invisiabled" />
	</div>
</template>
<script>
import msDragable from '@/components/msdragable/vue-drag-resize.vue';
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';
import help from './help.vue';
export default {
	name: 'MsPopup',
	mixins: [help],
	components: {
		msDragable,
	},
	props: {
		//Trạng thái đóng mở popup
		active: {
			default: false,
			type: Boolean,
		},
		//Độ rộng của popup
		width: {
			default: 0,
			type: Number,
		},
		//Độ cao của popup
		height: {
			default: 0,
			type: Number,
		},
		//Cấu hình popup hiện thị full màn hình
		fullScreen: {
			default: false,
			type: Boolean,
		},
		cssHeader: {
			default: null,
			type: String,
		},
		cssContent: {
			default: null,
			type: String,
		},
		cssFooter: {
			default: null,
			type: String,
		},
		cssPopup: {
			default: null,
			type: String,
		},
		fixHeight: {
			default: false,
			type: Boolean,
		},
		placement: {
			default: 'center',
			type: String,
		},
		animation: {
			default: null,
			type: String,
		},
		helpPath: {
			default: null,
			type: String,
		},
		iconClose: {
			default: true,
			type: Boolean,
		},
		hasDraggable: {
			default: true,
			type: Boolean,
		},
		defaultCssHeader: {
			default: true,
			type: Boolean,
		},
		defaultCssContent: {
			default: true,
			type: Boolean,
		},
		defaultCssFooter: {
			default: true,
			type: Boolean,
		},
		autoFocus: {
			default: true,
			type: Boolean,
		},
		forceRender: {
			default: false,
			type: Boolean,
		},
		minWidth: {
			default: null,
			type: Number,
		},
	},
	//Tính toán lại độ rộng,độ cao,vị trí của popup và đưa element popup ra ngoài body
	created() {
		const me = this;
		me.updateSizePopup();
		window.addEventListener('resize', me.updateSizePopup);
		EventBusGlobal.$on(
			GlobalEventName.closeAllPopup,
			me.closePopupFromInstance
		);
		me.helpId = me.helpPath;
	},
	mounted() {
		document.body.appendChild(this.$el);
		if (this.$refs.content) {
			this.$refs.content.addEventListener('scroll', this.raiseEventScroll);
		}
	},
	data() {
		this.popupItems = {};
		return {
			isDraggable: false,
			widthx: 0,
			heightx: 0,
			posX: 0,
			posY: 0,
		};
	},
	computed: {
		heightDefault() {
			const me = this;
			if (
				me.fullScreen ||
				me.height ||
				me.fixHeight ||
				me.placement != 'center'
			) {
				return null;
			}
			return { height: 'auto' };
		},
		customSize() {
			const me = this;
			if (me.minWidth) {
				return {
					minWidth: `${me.minWidth}px`,
				};
			}
			return null;
		},
	},
	watch: {
		width() {
			this.updateSizePopup();
		},
		height() {
			this.updateSizePopup();
		},
		active: {
			handler(newVal, oldVal) {
				const me = this;
				if (newVal == true && me.autoFocus) {
					me.$nextTick(() => {
						me.$ms.commonFunc.focusFirstControlInput(me.$el);
					});
				}
				if (newVal == false) {
					window.removeEventListener('popstate', me.historyState);
				} else {
					me.historyState();
					window.addEventListener('popstate', me.historyState);
					me.updateSizePopup();
				}
			},
		},
		helpPath: {
			handler(newVal, oldVal) {
				const me = this;
				me.helpId = me.helpPath;
			},
		},
	},
	methods: {
		historyState() {
			history.pushState(null, null, location.pathname);
		},
		focusFirstControl(e) {
			const me = this;
			me.$ms.commonFunc.focusFirstControlInput(me.$el);
		},
		raiseEventScroll(e) {
			EventBusGlobal.$emit(GlobalEventName.scrollEvent, e);
		},
		/**
		 * Hàm đóng popup từ bên trong instance cập nhật 2 chiều lại giá trị active
		 */
		closePopupFromInstance(e) {
			const me = this;
			me.$emit('update:active', false);
		},
		/**
		 * Cập nhật lại độ rộng vào độ cao của grid khi kích cỡ màn hình thay đổi
		 * Created by LTDAT 26.06.2020
		 */
		updateSizePopup() {
			let me = this,
				windowWidth = me.getWindowWidth(),
				windowHeight = me.getWindowHeight();
			if (me.fullScreen) {
				me.widthx = windowWidth;
				me.heightx = windowHeight;
				me.posX = 0;
				me.posY = 0;
			} else if (me.placement == 'right') {
				me.widthx = me.width ? me.width : windowWidth / 2;
				me.heightx = windowHeight;
				me.posX = windowWidth - me.widthx;
				me.posY = 0;
			} else {
				me.widthx = me.width ? me.width : windowWidth / 2;
				me.heightx = me.height ? me.height : windowHeight / 2;

				me.posX = (windowWidth - me.widthx) / 2;
				me.posY = (windowHeight - me.heightx) / 2;
			}
		},
		/**
		 * Đưa popup về giữa màn hình
		 */
		setMiddlePosition() {
			let me = this,
				windowWidth = me.getWindowWidth(),
				windowHeight = me.getWindowHeight();
			me.$nextTick(() => {
				if (me.$refs.dragable) {
					if (!me.height) {
						me.heightx = me.$refs.dragable.$el.offsetHeight;
						me.posX = (windowWidth - me.widthx) / 2;
						me.posY = (windowHeight - me.heightx) / 2;
					}
				}
			});
		},
		/**
		 * Lấy độ rộng của màn hình
		 * Created by LTDAT 26.06.2020
		 */
		getWindowWidth() {
			let windowWidth =
				window.innerWidth ||
				document.documentElement.clientWidth ||
				document.body.clientWidth;
			return windowWidth;
		},
		/**
		 * Lấy độ cao của màn hình
		 * Created by LTDAT 26.06.2020
		 */
		getWindowHeight() {
			let windowHeight =
				window.innerHeight ||
				document.documentElement.clientHeight ||
				document.body.clientHeight;
			return windowHeight;
		},

		/**
		 * Xử lý sự kiện keydown trên popup
		 * Created by LTDAT 26.06.2020
		 */
		onKeydown(e) {
			const me = this;
			if (e.which == 27) {
				me.closePopup();
			}
		},
		/**
		 * Sự kiện bắt đầu kéo di chuyển popup
		 */
		onDraggable(event) {
			const me = this;
			if (!me.fullScreen && me.placement == 'center' && me.hasDraggable) {
				EventBusGlobal.$emit('clickEventOther', event);
				me.isDraggable = true;
			}
		},
		/**
		 * Sự kiện thả di chuyển popup
		 */
		offDraggable() {
			const me = this;
			me.$nextTick(() => {
				me.$refs.dragable.active = false;
				me.isDraggable = false;
			});
		},
		//SỰ kiện đóng popup
		closePopup() {
			const me = this;
			let active = false;
			setTimeout(() => {
				me.$emit('close', active);
			}, 100);
		},
	},
	beforeDestroy() {
		const me = this;
		window.removeEventListener('resize', me.updateSizePopup);
		EventBusGlobal.$off('closeAllPopup', me.closePopupFromInstance);
		if (this.$refs.content) {
			this.$refs.content.removeEventListener('scroll', me.raiseEventScroll);
		}
	},
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msPopup.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msPopup.scss';
}
</style>